module.exports = __webpack_public_path__ + "img/logo-icon-app.383c5a36.png";